import React from 'react';
import PropTypes from 'prop-types';

import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

import theme from 'utils/theme';

const SkeletonLine = ({
  height,
  width,
  className,
  numberLines,
  color,
  highlightColor,
}) => (
  <SkeletonTheme
    color={color}
    highlightColor={highlightColor}
  >
    <Skeleton height={height} width={width} count={numberLines} className={className} />
  </SkeletonTheme>
);

SkeletonLine.defaultProps = {
  height: null,
  width: null,
  numberLines: 1,
  className: '',
  color: theme.colors['white-one'],
  highlightColor: theme.colors.white,
};

SkeletonLine.propTypes = {
  height: PropTypes.number,
  width: PropTypes.number,
  className: PropTypes.string,
  numberLines: PropTypes.number,
  color: PropTypes.string,
  highlightColor: PropTypes.string,
};

export default SkeletonLine;
